export default __webpack_public_path__ + "static/Galaxy-4faa7710da58d01da9fd2e79fe2663f3.png";